import { SolicitudesService } from './../../../services/solicitudes/solicitudes.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesStatus } from './../../../models/messages';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { Component, Output, EventEmitter } from '@angular/core';

export interface File {
  name: string;
  base64Input: string;
  type: string;
}

declare var $: any;
@Component({
  selector: 'app-respuesta-quejas-reclamos',
  templateUrl: './respuesta-quejas-reclamos.component.html',
  styleUrls: ['./respuesta-quejas-reclamos.component.scss'],
  providers:[
    MessagesStatus
  ]
})

export class RespuestaQuejasReclamosComponent{

  @Output() cerrarRespuestaSolicitud = new EventEmitter<boolean>();
  @Output() refresh = new EventEmitter<any>();
  user:any;
  loading:boolean;
  save:boolean = false;
  Email:any;
  Codigo:any;
  frmRespuesta: FormGroup;
  type:any;
  nameFile:any="Adjuntar Archivo"
  archivoEnBase64 : any;
  file:any;
  cont:number=0;
  files : File[] = [];
  extencion :any;
  constructor(private solicitudService : SolicitudesService,private msgStatus:MessagesStatus ) {

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.Email = solicitudService.datos.Email;
    this.Codigo = solicitudService.datos.Codigo;
    
    this.frmRespuesta = new FormGroup({
      "Email": new FormControl(this.Email, Validators.required),
      "idSolicitud": new FormControl(solicitudService.datos.idSolicitud,  Validators.required),
      "UsuarioAtencion":new FormControl(this.user.Usuario, Validators.required),
      "Respuesta":new FormControl('', Validators.required),
      "UrlRespuesta":new FormControl('', ),
      "file_name":new FormControl('', ),
      "file_content":new FormControl('', ),
      "file_type":new FormControl('', ),
      "Extencion":new FormControl('', )
     });

  }

  CerrarPopUp() {
    this.cerrarRespuestaSolicitud.emit();
  }

  addFile(){
    this.cont += 1;
    if( this.type){
      this.files.push({name: this.nameFile,base64Input: this.archivoEnBase64,type:this.type});
      this.type = '';
    }
  }

  deleteCharacter(value){
    this.cont -= 1;
    this.files = this.files.filter(
      element => {
        return element !== value;
      }
    );
  }
  enviarRespuesta(){

    if (this.archivoEnBase64) {
       this.extencion = this.file.slice( this.file.lastIndexOf('.'));
    }
    
      this.frmRespuesta.controls['file_name'].setValue(this.Codigo);  
      this.frmRespuesta.controls['file_content'].setValue(this.archivoEnBase64);  
      this.frmRespuesta.controls['file_type'].setValue(this.type);  
      this.frmRespuesta.controls['Extencion'].setValue(this.extencion);

      if (this.frmRespuesta.controls['Respuesta'].value == ''){
        this.showNotification('warning','top','right','Rellenar el campo Respuesta!! ');
        return;
        } 

     if (this.frmRespuesta.invalid){
      this.showNotification('warning','top','right','Verificar los campos resaltados de color rojo!! ');
      return;
      }  
    this.loading = true;
    this.solicitudService.guardarRespuesta(this.frmRespuesta.getRawValue())
    .subscribe( resp => {
      this.save = false;
      this.loading = false; 
      this.cerrarRespuestaSolicitud.emit();
      this.refresh.emit();
      this.showNotification('success','top','right','Respuesta enviada con éxito!! ');          
    },(err: HttpErrorResponse)=> {
      this.save = false;
      this.loading = false;
      if (err.error instanceof ErrorEvent) {
        console.error("Error Event");
      } else {
          this.msgStatus.getMessage(err.status); 
                    
      }
      this.showNotification('danger','top','right','RESPUESTA NO GUARDADO. '+this.msgStatus.message);
    
    }) 
  }

  onClick() {
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.onchange = () => {
      this.aBinario(fileUpload.files)
    };
    fileUpload.click();
  }

  aBinario(fileList: FileList){
    if (fileList.length === 0)
      return;

    let file = fileList[0];
    
    this.file = file.name;
    this.type = file.type;
    this.nameFile = this.file
    let fileReader: FileReader = new FileReader();
    var base64;
    var archivo64;
    var self = this;
    fileReader.onload =  function(fileLoadedEvent) {
              base64 = fileLoadedEvent.target['result'];
              archivo64 = base64.split(',',2);  
              self.archivoEnBase64 = archivo64[1];
           };
           
    fileReader.readAsDataURL(file);
  }

  
  showNotification(type,from,align,message){
  
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

}
